import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';

export class VafaOptOutQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.VafaOptOutQualifier';

    public static readonly NAME: string = 'Value Added Fees: Opt Out';

    constructor(qual?: IQualifier) {
      super(VafaOptOutQualifier.CLASS, qual ? qual.id : null);
    }

    /* eslint-disable class-methods-use-this */
    getDescription(): string {
      return 'Value Added Fees: Opt Out';
    }
    /* eslint-enable class-methods-use-this */

    clone(): IQualifier {
      const clone = new VafaOptOutQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default VafaOptOutQualifier;
